import funciones from "./funcion/funcion";
import sistema from "./sistema/equitas";
import catalogos from "./catalogos/catalogos";

const EQUITAS = {
  sistema: sistema,
  catalogos: catalogos,
  funciones: funciones
}

export default EQUITAS


//////////////////
// WEBPACK FOOTER
// ./static/js/api/EQUITAS/equitasapi.js
// module id = null
// module chunks = 